// stores/storeDismissedMessages.js
import { defineStore } from 'pinia'

export const useStoreDismissedMessages = defineStore('storeDismissedMessages', {
  state: () => ({
    dismissedMessageId: 'null',
  }),
  actions: {
    saveDismissedMessage(messageId) {
      this.dismissedMessageId = messageId;
    },
    clearDismissedMessages(){
      this.dismissedMessageId = null;
    }
  },
  getters: {
    getMessageId: (state) => () => state.dismissedMessageId,
  },
  persist: true,
})
